import { UiActions, TOGGLE_SIDENAV } from './ui.actions';

export interface State {
  showSidebar: boolean;
}

const initialState: State = {
  showSidebar: false
};

export function uiReducer(state = initialState, action: UiActions) {
  switch (action.type) {
    case TOGGLE_SIDENAV:
      return {
        ...state,
        showSidebar: !state.showSidebar
      };
    default: {
      return state;
    }
  }
}

export const getSidenavIsOpened = (state: State) => state.showSidebar;
